import { render } from "./PdfA4Page.vue?vue&type=template&id=120451ac&scoped=true&ts=true"
import script from "./PdfA4Page.vue?vue&type=script&lang=ts"
export * from "./PdfA4Page.vue?vue&type=script&lang=ts"

import "./PdfA4Page.vue?vue&type=style&index=0&id=120451ac&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120451ac"]])

export default __exports__